import type { NavLink, ToolNavItem } from '@/types'

import { PHOTO, UI } from '@/constants/media'
import { LINKS } from '@/constants/site'

export const TOOLS: ToolNavItem[] = [
    {
        slug: 'befaring',
        name: 'Befaring',
        href: '/befaring',
        tagline: "Bare ta én runde med mobilen.",
        image: UI.scanArRoom
    },
    {
        slug: 'kalkulasjon',
        name: 'Kalkulasjon',
        href: '/kalkulasjon',
        tagline: "Kursfritt kalkulasjonsverktøy",
        image: UI.pristilbudPdf
    },
    {
        slug: 'ressursplanlegger',
        name: 'Ressursplanlegger',
        href: '/ressursplanlegger',
        tagline: "Planlegg prosjekter og ressurser",
        image: UI.plannerDrag
    },
    {
        slug: 'kvalitetssikring',
        name: 'Kvalitetssikring',
        href: '/kvalitetssikring-app-for-handverkere',
        tagline: "Sjekklister, avvik og bilder",
        image: UI.checklistHeight
    },
    {
        slug: 'hms',
        name: 'HMS-system',
        href: '/hms-app-for-handverkere',
        tagline: "Lovpålagt sikkerhet gjort enkelt",
        image: PHOTO.hmsInspection
    },
    {
        slug: 'timeregistrering',
        name: 'Timeregistrering',
        href: '/timeregistrering',
        tagline: "Før timer raskt og riktig",
        image: UI.stampInPhone
    },
    {
        slug: 'sentral-godkjenning',
        name: 'Sentral godkjenning',
        href: '/sentral-godkjenning',
        tagline: "Lynrask søknadsprosess",
        image: PHOTO.sentraltGodkjent
    },
    {
        slug: 'integrasjoner',
        name: 'Integrasjoner',
        href: '/integrasjoner',
        tagline: "Sømløs flyt av data",
        image: UI.integrationsGrid
    }
]

export const RESOURCES: NavLink[] = [
    { label: 'Blogg', href: '/blogg', description: "Kunnskap som lønner seg" },
    { label: 'Webinar', href: '/webinar', description: "Se gratis, her og nå" },
    { label: 'Håndverkerordboken', href: '/haandverkerordboken', description: "Ord og forkortelser fra byggeplassen" },
    { label: 'Hjelpesenter', href: LINKS.help, description: "Svar på det meste", external: true }
]

export const COMPANY: NavLink[] = [
    { label: 'Om oss', href: '/om-svenn' },
    { label: 'Kunder', href: '/blogg?kategori=kundehistorier' },
    { label: 'Priser', href: '/priser' },
    { label: 'Blogg', href: '/blogg' },
    { label: 'Ledige stillinger', href: '/ledige-stillinger' },
    { label: 'Kontakt oss', href: '/kontakt' }
]

export const SOCIAL: NavLink[] = [
    { label: 'YouTube', href: LINKS.youtube, external: true },
    { label: 'LinkedIn', href: LINKS.linkedin, external: true },
    { label: 'Instagram', href: LINKS.instagram, external: true },
    { label: 'Facebook', href: LINKS.facebook, external: true }
]

const ROUTE_TITLES: Record<string, string> = {
    '/': 'Svenn',
    '/priser': 'Priser',
    '/om-svenn': 'Om oss',
    '/kontakt': 'Kontakt',
    '/bli-oppringt': 'Bli oppringt',
    '/ledige-stillinger': 'Stillinger',
    '/blogg': 'Bloggen',
    '/webinar': 'Webinar',
    '/haandverkerordboken': 'Ordboken'
}

TOOLS.forEach(tool => {
    ROUTE_TITLES[tool.href] = tool.name
})

export const titleForPath = (path: string): string => {
    const clean = path.split(/[?#]/)[0].replace(/\/$/, '') || '/'

    if (ROUTE_TITLES[clean]) return ROUTE_TITLES[clean]
    if (clean.startsWith('/blogg/')) return 'Bloggen'
    if (clean.startsWith('/haandverkerordboken/')) return 'Ordboken'
    if (clean.startsWith('/ledige-stillinger/')) return 'Stillinger'

    return 'Svenn'
}
